import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "external-mam-search-results-name-cell",
  templateUrl: `./external-mam-search-results-status-cell.component.html`,
  styleUrls: ["./external-mam-search-results-status-cell.component.scss"],
})
export class ExternalMAMSearchResultsStatusCell
  implements ICellRendererAngularComp
{
  imported: boolean;
  loaded: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.updateParams(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateParams(params);
    return true;
  }

  updateParams(params: ICellRendererParams) {
    if (!params?.data) {
      return;
    }
    this.imported = params?.data?.isEvrideoImported;
    this.loaded = true;
  }
}
